<template>
	<div v-show="showOverlay" class="popup-overlay">
		<!-- Top Bar -->
		<div class="overlay-top-bar">
			<button class="back-button" @click="handleCancel"><InlineSvg src="/images/icons/ic-arrow-left.svg" /></button>
			<button v-if="enableFileUpload" class="top-action-button" @click="handleChooseNewFile">{{ $t('Choose new photo') }}</button>
		</div>

		<div class="overlay-content">
			<ImageCropper
				ref="imageCropper"
				:stencilType="stencilType"
				:aspectRatio="aspectRatio"
				:isMobile="true"
				@imageCropped="imageCropped"
				@ready="cropperReady = true"
				@failInit="handleCancel"
			/>
		</div>

		<!-- Footer -->
		<div class="overlay-footer">
			<AppButton class="footer-button" outline @click="handleCancel"
				><span class="override-text-style">{{ $t('Cancel') }}</span></AppButton
			>
			<AppButton class="footer-button" @click="handleSave" :disabled="!cropperReady" :loading="loading"
				><span class="override-text-style">{{ $t('Use this photo') }}</span></AppButton
			>
		</div>

		<FileUpload
			v-if="enableFileUpload"
			ref="file-upload"
			@filePicked="filePicked"
			@assetUp="imageUploaded"
			accepts="image/jpg,image/jpeg,image/png,image/gif"
			:multiple="false"
			:confirmUpload="false"
		/>
	</div>
</template>

<script>
	import FileUpload from '~/stan-vue-shared/components/FileUpload'
	import ImageCropper from './ImageCropper'

	export default {
		name: 'ImageCropperOverlay',
		components: {
			FileUpload,
			ImageCropper,
		},
		props: {
			stencilType: { type: String, default: 'rectangle' },
			enableFileUpload: { type: Boolean, default: false },
			aspectRatio: { type: Number, default: 1 },
		},
		data() {
			return {
				showOverlay: false,
				cropperReady: false,
				loading: false,
			}
		},
		computed: {
			saveDisabled() {
				return !this.filename
			},
		},
		methods: {
			init(file) {
				this.$refs.imageCropper.init(file)
				this.showOverlay = true
			},
			handleChooseNewFile() {
				this.$refs['file-upload'].onPickFile()
			},
			handleCancel() {
				this.loading = false
				this.showOverlay = false
				this.$refs.imageCropper.cancelFile()
				this.$emit('cancel')
			},
			handleSave() {
				this.loading = true
				this.$refs.imageCropper.crop()
			},
			imageCropped(data) {
				this.$emit('imageCropped', data)
				this.loading = false
				this.showOverlay = false
				if (this.enableFileUpload) {
					this.$refs['file-upload'].uploadFile(data.file)
				}
			},
			filePicked(files) {
				const file = files[0]
				this.init(file)
			},
			imageUploaded(uploadPayload) {
				this.$emit('uploaded', uploadPayload)
				this.loading = false
			},
		},
	}
</script>

<style lang="scss" scoped>
	.popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100dvh;
		background-color: #ffffff;
		z-index: 9999;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	/* Top bar */
	.overlay-top-bar {
		display: flex;
		justify-content: space-between;
		padding: 16px 8px;
		z-index: 1;
		height: 60px;

		.back-button {
			background: none;
			border: none;
			font-size: 16px;
			color: #333;
			cursor: pointer;
		}

		.top-action-button {
			width: 130;
			height: 30;
			border-radius: 20px;
			padding-top: 7px;
			padding-right: 13px;
			padding-bottom: 7px;
			padding-left: 13px;
			gap: 8px;
			background: #f2f4f8;

			font-family: Inter;
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			letter-spacing: -2%;
			color: #131f60;

			cursor: pointer;
		}
	}

	.overlay-content {
		flex: 1 1 auto;
		overflow-y: auto;
		padding: 0;
	}

	/* Footer - position it at the bottom */
	.overlay-footer {
		height: 66px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: white;
		padding: 12px 16px;
		display: flex;
		gap: 12px;
		width: 100%;
		box-sizing: border-box;

		.footer-button {
			flex: 1;
			.button-content {
				.override-text-style {
					font-family: Inter !important;
					font-weight: 400 !important;
					font-size: 14px !important;
					line-height: 140% !important;
					letter-spacing: 0.2px;
				}
			}
		}
	}
</style>
<style>
	.vue-advanced-cropper-foreground {
		background: white;
	}
	.vue-advanced-cropper-background {
		background: white;
	}
</style>
